import { ConnectionPositionPair, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, ElementRef, Injector, Input, Renderer2 } from '@angular/core';

import { BaseErrorsDirective } from './base-errors.directive';
import { ErrorsComponent } from './errors.component';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `
    pcs-input[formControl][container='body'],pcs-input[formControlName][container='body'],
    pcs-input[ngrxFormControlState][container='body'],
    pcs-textarea[formControl][container='body'],pcs-textarea[formControlName][container='body'],
    pcs-textarea[ngrx-form-control-state][container='body'],
    pcs-datepicker[formControl][container='body'],pcs-datepicker[formControlName][container='body'],
    pcs-datepicker[ngrxFormControlState][container='body'],
    pcs-single-select[formControl][container='body'],pcs-single-select[formControlName][container='body'],
    pcs-single-select[ngrxFormControlState][container='body'],
    pcs-multi-select[formControl][container='body'],pcs-multi-select[formControlName][container='body'],
    pcs-multi-select[ngrxFormControlState][container='body']
  `
})
export class BodyErrorsDirective extends BaseErrorsDirective {
  @Input() container: 'body' | null = null;

  private overlayRef: OverlayRef = null;

  constructor(
    protected readonly injector: Injector,
    protected readonly element: ElementRef,
    protected readonly renderer: Renderer2,
    private readonly overlay: Overlay
  ) {
    super(injector, element, renderer);
  }

  protected attach() {
    this.overlayRef = this.overlay.create({
      positionStrategy: this.positionStrategy(),
      scrollStrategy: this.overlay.scrollStrategies.reposition()
    });

    this.overlayRef.attach(this.errorsComponentPortal());
  }

  protected detach() {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef = null;
    }
  }

  private positionStrategy() {
    return this.overlay.position()
      .flexibleConnectedTo(this.origin())
      .withPositions(this.positions());
  }

  private origin() {
    return this.element.nativeElement;
  }

  private positions(): ConnectionPositionPair[] {
    return [
      {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
        offsetY: -8,
      }
    ];
  }

  private errorsComponentPortal() {
    return new ComponentPortal(ErrorsComponent, null, this.errorsComponentInjector());
  }

}
